module.exports = __webpack_public_path__ + "img/redis.8347dd1e.svg";